
export const transformStepTypeInputStatus = (stepTypeInputStatus, steps) => {
    return steps.map((step) => {
      const stepType = String(step.type);
      return { [stepType]: stepTypeInputStatus[stepType] ?? false };
    });
  };

export const enforceFalseAfterFirstFalse = (inputArray) => {
    let foundFirstFalse = false;
    return inputArray.map(obj => {
      const key = Object.keys(obj)[0];
      if (foundFirstFalse) {
        return { [key]: false };
      }
      if (!obj[key]) {
        foundFirstFalse = true;
      }
      return obj;
    });
  };


  export const findValueByKey = (inputArray, searchKey) => {
    searchKey = String(searchKey)
    const foundItem = inputArray.find(obj => Object.keys(obj)[0] === searchKey);
    return foundItem ? foundItem[searchKey] : null;
  };

export function updateObjectAfterFirstFalse(inputObj) {
  let foundFalse = false;

  return Object.keys(inputObj).reduce((acc, key) => {
    const innerKey = Object.keys(inputObj[key])[0];
    const value = inputObj[key][innerKey];

    if (foundFalse) {
      acc[key] = { [innerKey]: false };
    } else {
      acc[key] = { [innerKey]: value };
      if (value === false) {
        foundFalse = true;
      }
    }

    return acc;
  }, {});
}